import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	rootHeader: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		marginTop: "15px",
		marginBottom: "15px",
		fontSize: "18px",
		lineHeight: "2",
		letterSpacing: "2px",
		textTransform: "uppercase",
		textAlign: "center",
		fontFamily: theme.fonts.bold,
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		rootHeader: {
			wordWrap: "break-word",
			fontSize: "16px",
			lineHeight: "1.5",
			paddingLeft: "20px",
			paddingRight: "20px",
		},
	},
}));

const HeaderV2 = ({ textHeader }) => {
	const { rootHeader } = useStyles();
	return <div className={rootHeader}>{textHeader}</div>;
};

export default HeaderV2;
